const mutations = {
  addDataApi: (state, payload) => {
    state.dataAPI = payload;
  },
  removeDataApi: (state) => {
    state.dataAPI = "";
  },
  addDataLogin: (state, payload) => {
    state.dataLogin = payload;
  },
  addDataRegister: (state, payload) => {
    // console.log(payload);
    state.dataRegisterAuth = {
      telp: payload.noTelp,
      password: payload.passwordUser,
      nama: payload.namaAkun,
    };
  },
  requestDataOtp: (state, payload) => {
    // console.log(payload);
    state.dataOtpAuth = payload;
  },
  addDataOtp: (state, payload) => {
    state.dataRegisterAuth = {
      otp: payload,
    };
  },
  addDataRegis: (state, payload) => {
    state.dataRegis = payload;
  },

  requestDataOtpForgot: (state, payload) => {
    // console.log(payload);
    state.dataOtpForgotAuth = payload;
  },

  requestPasswordChange: (state, payload) => {
    // console.log(payload);
    state.dataPasswordChange = payload;
  },

  storeOtp: (state, payload) => {
    state.dataOtpGanti = payload;
  },
};

export default mutations;
